import { Query, QueryResult } from "material-table";
import qs from "qs";

import { ApiService } from "services/Api.service";

import {
  PrizeSupplier,
  PrizeSupplierDTO
} from "models/prize/supplier/PrizeSupplier";

import { EditPrizeSupplierFormValues } from "components/prize/supplier/edit/Edit";
import { constructQueryParams } from "utils/query/constructQueryParams";

export interface PrizeSupplierServiceInterface {
  list(
    query: Query<PrizeSupplier>,
    params?: any
  ): Promise<QueryResult<PrizeSupplier>>;
  get(prizeSupplier: PrizeSupplier): Promise<PrizeSupplier>;
  edit(
    prizeSupplier: PrizeSupplier,
    values: EditPrizeSupplierFormValues
  ): Promise<PrizeSupplier>;
}

export class PrizeSupplierService implements PrizeSupplierServiceInterface {
  private _apiService: ApiService;

  constructor(apiService: ApiService) {
    this._apiService = apiService;
  }

  async list(
    query: Query<PrizeSupplier>,
    params?: any
  ): Promise<QueryResult<PrizeSupplier>> {
    const queryParams = {
      ...constructQueryParams<PrizeSupplier>(query),
      ...params
    };

    const { count, list } = await this._apiService.get(
      "/steve/admin/supplier",
      {
        searchFields: [],
        ...queryParams
      },
      {
        paramsSerializer: (params: any) => qs.stringify(params)
      }
    );

    return {
      totalCount: count,
      page: query.page,
      data: list.map((prizeSupplier: PrizeSupplierDTO) =>
        PrizeSupplier.create(prizeSupplier)
      )
    };
  }

  async get(prizeSupplier: PrizeSupplier): Promise<PrizeSupplier> {
    return await Promise.resolve(prizeSupplier);
  }

  async edit(
    prizeSupplier: PrizeSupplier,
    values: EditPrizeSupplierFormValues
  ): Promise<PrizeSupplier> {
    return await this._apiService.put(
      `/steve/admin/supplier/${prizeSupplier.id}`,
      values
    );
  }
}
